export default {
    routerName: '图片编辑',
    routerNamePic: '图片裁剪',
    pic: {
        name: '图片名',
        thumb: '缩略图',
        image: '图片',
        status: '状态',
        open: '启用',
        close: '停用',
        description: '描述',
        sortOrder: '排序',
        type: '类型',
    },
};
